import { render, staticRenderFns } from "./DriverFeesList.vue?vue&type=template&id=4b7302c6&scoped=true"
import script from "./DriverFeesList.vue?vue&type=script&lang=js"
export * from "./DriverFeesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7302c6",
  null
  
)

export default component.exports